import { defineAsyncComponent } from 'vue'
export default {
  about: defineAsyncComponent(() => import("/home/runner/work/seed/seed/layouts/about.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/runner/work/seed/seed/layouts/default.vue").then(m => m.default || m))
}